module.exports = __webpack_public_path__ + "img/double-sided-decorative.b1875a92.jpg";